export let futureActionAcceptableResults = [
  // 输入重采价格
  { key: 'WAITING_SAMPLE_RECOLLECT', value: '重采' },
  // 上传突变验证报告
  { key: 'MUTATION_VERIFICATION', value: '上传突变验证报告' },
  // 以下状态直接确认，没有额外输入
  { key: 'AGENT_WAITING_SAMPLE_RECOLLECT', value: '重采' }, // 非商城重采
  { key: 'SAMPLE_RECOLLECT', value: '创建重采订单' },
  { key: 'ORDER_CLOSE', value: '关闭' },
  { key: 'RISK_TEST', value: '风险上机' },
  { key: 'RETEST', value: '重新上机' },
  { key: 'REPORT_GENERATE_FORCE', value: '出报告' },
  { key: 'REPORT_GENERATE', value: '重出报告' },
  { key: 'REDO_REPORT_GENERATE', value: '重新计算' },
  { key: 'QUALIFIED', value: '审核通过' },
  { key: 'CONFIRMED', value: '提交市场专员审核' },
  { key: 'APPROVED', value: '审核通过' },
  { key: 'REDO_DNA_EXTRACT', value: '重新核酸提取' },
  { key: 'CONTINUE_TO_TEST', value: '继续上机' },
  { key: 'ABANDON', value: '废弃' },
  { key: 'CONTINUE', value: '继续' },
  { key: 'CANCEL', value: '取消废弃' },
  { key: 'CANCEL_DELETE', value: '取消删除' },
  { key: 'DELETE', value: '确认删除' }
]
export let detectionCategory = [
  { key: 'COMMON_DISEASES', value: '常见疾病' },
  { key: 'GENETIC_DISEASES', value: '高危遗传病' },
  { key: 'RARE_DISEASES', value: '罕见病' },
  { key: 'PHARMACOGENOMICS', value: '药物基因组' },
  { key: 'LIFE_STYLE', value: '生活方式' },
  { key: 'ANCESTRY', value: '祖源' }
]
export let categoryType = [
  { key: 'COMMON_DISEASES', value: '疾病' },
  { key: 'GENETIC_DISEASES', value: '高危遗传病' },
  { key: 'RARE_DISEASES', value: '罕见病' },
  { key: 'PHARMACOGENOMICS', value: '药物成分' },
  { key: 'LIFE_STYLE', value: '生活方式' }
]
export let detectionType = [
  { key: 'cancer', value: 'COMMON_DISEASES' },
  { key: 'life-style', value: 'LIFE_STYLE' },
  { key: 'medicine', value: 'PHARMACOGENOMICS' },
  { key: 'high-risk', value: 'GENETIC_DISEASES' },
  { key: 'rare-disease', value: 'RARE_DISEASES' }
]
export let ConfigType = [
  { key: 'RISK', value: '易感模型' },
  { key: 'CAUSAL', value: '致病模型' },
  { key: 'LH', value: '乐活模型' },
  { key: 'CAUSAL_AUTO', value: '致病模型(自动)' },
  { key: 'MT_HAPLO_TYPE', value: '母系祖源单倍型' },
  { key: 'Y_HAPLO_TYPE', value: '父系祖源单倍型' },
  { key: 'ANCESTRY_COMPOSITION', value: '祖源成分' },
  { key: 'NEANDERTHAL', value: 'Neanderthal比例' }
]
export let ConfigSex = [
  { key: 'M', value: '男性专用' },
  { key: 'F', value: '女性专用' },
  { key: 'MF', value: '男女通用' }
]
export let detectionChineseType = [
  { key: '疾病', value: '疾病' },
  { key: '药物成分', value: '药物成分' },
  { key: '生活方式', value: '生活方式' },
  { key: '高危遗传病', value: '高危遗传病' },
  { key: '罕见病', value: '罕见病' },
  { key: '祖源', value: '祖源' }
]
export let operationLog = [
  { key: 'WAITING_SAMPLE_RECOLLECT', value: '确认样本重采' },
  { key: 'ORDER_CLOSE', value: '关闭订单' },
  { key: 'NOT_QUALIFIED_WAIT_FUTURE_ACTION', value: '操作了不合格' },
  { key: 'AGENT_WAITING_SAMPLE_RECOLLECT', value: '确认样本重采' },
  { key: 'ABANDON_WAITING_FUTURE_ACTION', value: '操作了废弃' }
]
export let packageProductTypes = [
  { key: 'PROPRIETARY', value: '中源协和计算' },
  { key: 'THIRDPARTY', value: '第三方出报告' }
]
export let certificatesTypeMap = {
  'CHINESE_IDENTITY_CARD': '身份证',
  'MILITARY_ID': '军官证',
  'PASSPORT': '护照'
}
export let sexMapEnglish = {
  0: 'FEMALE',
  1: 'MALE'
}
export let labOrderSaleFrom = [
  { value: 'MALL', label: '线上订单' },
  { value: 'CPS', label: 'CPS订单' },
  { value: 'CHANNEL', label: '渠道订单' }
]
export let adultOrderSaleFrom = [
  { value: 'MALL', label: '线上订单' },
  { value: 'CHANNEL', label: '渠道订单' }
]
export let typeName = [
  { value: 'BRANCH', label: '分/子公司' },
  { value: 'AGENT', label: '外部代理商' }
]
export let holidayType = [{
  label: '法定节假日',
  value: 'LEGAL_HOLIDAYS'
}, {
  label: '调休',
  value: 'LEAVE_IN_LIEU'
}, {
  label: '补班',
  value: 'MAKE_UP_FOR_WORK'
}]
